// extracted by mini-css-extract-plugin
module.exports = {"main-component":"triangleBackground_main-component__NBxks"};